import React from "react";
import { Modal } from "react-bootstrap";
import { Row, Col } from "reactstrap";
import moment from "moment";
import PendingTransactions from "../pending-transactions";
type TrxHistory = {
  action: string;
  updated_by_role: string;
  updated_by: string;
  updated_at: string;
  created_by: string;
  created_at: string;
  note: string;
  check_list?: any;
};

type TxnData = {
  _id: string;
  has_sub_transactions?: boolean;
  [key: string]: any;
};

type ReusableModalProps = {
  show: boolean;
  viewChildrensListing?: any;
  title?: string;
  onClose: () => void;
  data?: TxnData;
  trxHistory?: TrxHistory[];
  onHistoryClick?: (hist: TrxHistory) => void;
  children?: React.ReactNode;
};

const ReusableModal: React.FC<ReusableModalProps> = ({
  show,
  viewChildrensListing = "",
  title = "View Transaction",
  onClose,
  data,
  trxHistory = [],
  onHistoryClick,
  children,
}) => {

  return (
    <Modal
      // className="mx-2 w-full"
      // dialogClassName="modal100w"
      className=""
      dialogClassName={"modal90w"}
      show={show}
      size="xl"
      backdrop={true}
      onHide={onClose}
    >
      <div className="modal-header">
        <button
          aria-hidden={true}
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={onClose}
        >
          <i className="tim-icons icon-simple-remove" />
        </button>
        <h6 className="title title-up">{title}</h6>
      </div>

      <div className="modal-body">
        <div>
          {!viewChildrensListing ?
            <h4 className="card-title">
              <i className="fa fa-angle-left mr-2 pointer" onClick={onClose}></i>
              {title}
            </h4> : null}

          {!viewChildrensListing ? children : null}

          {data?.has_sub_transaction &&
            viewChildrensListing &&
            (
              <div>
                {!viewChildrensListing ? <h1 className="m-3">Showing Child Transaction</h1> : null}

                <PendingTransactions hasChild={data._id} />
              </div>
            )}

          {trxHistory.length > 0 && (
            <>
              <div className="line"></div>
              <Row className="pb-5">
                {trxHistory.map((hist, index) => (
                  <Col
                    md="3"
                    key={index}
                    onClick={() => onHistoryClick?.(hist)}
                  >
                    <div className="card process-card pointer">
                      <div className="card-header">
                        <h4 className="card-title">
                          <i className="tim-icons icon-single-02 mr-1"></i>
                          <span className="card-number">{index + 1}</span>
                          {hist.updated_by_role}
                        </h4>
                      </div>
                      <div className="card-body text-center">
                        <p className="small mt-2">Status:</p>
                        <h3 className="accepted text-primary">{hist.action}</h3>

                        {hist.updated_at && (
                          <>
                            <p className="small mt-2">by</p>
                            <h4 className="comment text-primary">
                              {hist.updated_by}
                            </h4>
                            <p className="small mt-2">at</p>
                            <h4 className="comment text-primary">
                              {moment(hist.updated_at).format(
                                "DD-MM-YYYY, h:mm a"
                              )}
                            </h4>
                          </>
                        )}

                        {hist.note && (
                          <>
                            <p className="small mt-2">Comment</p>
                            <small
                              className="comment dot-text"
                              title={hist.note}
                            >
                              {hist.note}
                            </small>
                          </>
                        )}

                        {hist.created_by && (
                          <>
                            <p className="small mt-2">by</p>
                            <h4 className="text-primary">{hist.created_by}</h4>
                            <p className="small mt-2">at</p>
                            <h4 className="comment text-primary">
                              {moment(hist.created_at).format(
                                "DD-MM-YYYY, h:mm a"
                              )}
                            </h4>
                          </>
                        )}
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default ReusableModal;
